import React from "react";
import { motion } from "framer-motion";
import { MapPin, Clock, ArrowUpRight } from "lucide-react";
import { whatsappLink } from "@/lib/site";

export const Location = () => {
  return (
    <section
      id="location"
      data-testid="location-section"
      className="relative py-20 sm:py-28 lg:py-36 border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-12 items-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="lg:col-span-5"
        >
          <div className="text-xs uppercase tracking-[0.3em] text-[#00E5FF] mb-4">Training Location</div>
          <h2 className="font-display text-4xl lg:text-5xl xl:text-6xl font-extrabold leading-[1.05] tracking-[-0.02em] text-white">
            Train inside <span className="text-gradient-blue">Dubai Mall.</span>
          </h2>
          <div className="mt-8 space-y-5">
            <div className="flex items-start gap-3">
              <MapPin className="w-5 h-5 text-[#00E5FF] mt-1" />
              <div>
                <div className="font-display text-white font-semibold text-lg">
                  Train Strength &amp; Fitness
                </div>
                <div className="text-zinc-400 text-sm mt-1">
                  Dubai Mall · Zabeel Expansion, Dubai, UAE
                </div>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <Clock className="w-5 h-5 text-[#00E5FF] mt-1" />
              <div>
                <div className="font-display text-white font-semibold text-lg">
                  Flexible Coaching Hours
                </div>
                <div className="text-zinc-400 text-sm mt-1">
                  By appointment · Online sessions available globally
                </div>
              </div>
            </div>
          </div>
          <p className="mt-8 text-zinc-400 text-sm leading-relaxed max-w-md">
            Corrective Motion provides personal training across Dubai. Most sessions run
            at Train Strength &amp; Fitness in the Dubai Mall Zabeel expansion, with home
            personal training available in select areas and online coaching worldwide.
          </p>
          <a
            href={whatsappLink("Hi Anoop, I'd like to know your available training slots.")}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="location-cta"
            className="mt-10 inline-flex items-center gap-2 bg-gradient-to-r from-[#0055FF] to-[#00E5FF] text-black px-6 py-3.5 rounded-full font-semibold hover:shadow-[0_0_30px_-5px_rgba(0,229,255,0.5)] transition-shadow"
          >
            Check Available Slots
            <ArrowUpRight className="w-4 h-4" />
          </a>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.1 }}
          className="lg:col-span-7"
        >
          <div className="relative rounded-3xl overflow-hidden ring-1 ring-white/10 glass">
            <div className="aspect-[16/11] w-full">
              <iframe
                title="Train Strength & Fitness, Dubai Mall"
                src="https://www.google.com/maps?q=Train+Strength+and+Fitness+Dubai+Mall+Zabeel&output=embed"
                className="w-full h-full grayscale-[60%] contrast-110 brightness-90"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
            <div className="absolute top-5 left-5 glass rounded-full px-4 py-2 text-xs uppercase tracking-[0.2em] text-white flex items-center gap-2">
              <span className="w-2 h-2 rounded-full bg-[#00E5FF] animate-pulse"></span>
              Currently Coaching Here
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Location;
